import { Route, Switch } from "react-router";
import { AppRouteUi } from "../../../config/appRoute";
import { PagePatientView } from "./pagePatientView";
import { PagePatientAdd } from "./pagePatientAdd";
import { PageSinglePatient } from "./pageSinglePatient";
import { PagePatientUpdate } from "./pagePatientUpdate";
import { RedirectRoute } from "../../../components/redirectRoute";

export function PagePatient(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route
          path={AppRouteUi.Patient.List()}
          exact
          component={PagePatientView}
        />
        <Route
          path={AppRouteUi.Patient.Add()}
          exact
          component={PagePatientAdd}
        />
        <Route
          path={AppRouteUi.Patient.Update()}
          component={PagePatientUpdate}
        />
        <Route path={AppRouteUi.Patient.ById()} component={PageSinglePatient} />
        <RedirectRoute
          from={AppRouteUi.Patient.Root()}
          to={AppRouteUi.Patient.List()}
          wildcardOpt={{
            defaultTo404Page: true,
          }}
        />
      </Switch>
    </div>
  );
}
